import styled from 'styled-components';

import Text from 'components/_core/Text';
import Row from 'components/Row';

export const Title = styled(Text).attrs({
  fontWeight: 'weight-500',
  variant: 'primary',
})`
  display: block;
`;

export const TopBarContainer = styled(Row).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  height: 100%;
  padding: 0 ${({ theme }) => theme.spacings.abs24}px;
`;
